import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actionCreators, sliceKeys } from '../../../model';

const { roomsCountSet } = actionCreators[sliceKeys.houses];

const RoomsCountSetter = ({ data, children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const counts = new Map();

    data.forEach((room) => {
      const count = counts.get(room.houseId) || 0;
      counts.set(room.houseId, count + 1);
    });

    dispatch(roomsCountSet(counts));
  }, [data, dispatch]);

  return <>{children}</>;
};

export default RoomsCountSetter;
